import { ListDefinition } from "../../param/listDefinitionType";
import { processSearchPatternFunctions } from "./patternFunctions";

export const createRegex = (
  input: string,
  listDefinitionsTable: Record<string, ListDefinition>
): RegExp => {
  const pattern = processSearchPatternFunctions(input, listDefinitionsTable);
  return new RegExp(pattern[0], "gu");
};
